import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValSpecialCharacters } from "../../../Validators/ValSpecialCharacters";
import PendingIcon from "@mui/icons-material/Pending";
import ErrorIcon from "@mui/icons-material/Error";
import { ValFormReg } from "../../../Validators/ValForms";
import { RegularExpressions } from "../../../Helpers/RegularExpression";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PercentIcon from '@mui/icons-material/Percent';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';



export const ValidarCondcionesOperacion = ({
  folio,
  setLoader,
  loader,
  updateComentarios,
  idproceso,
  // Inyectado por ModalSolicitudCredito/ModalSolicitudCreditoJDF (ver
  // ModalSCScreens). Habilita "Siguiente" tras aceptar, sin cerrar el modal.
  habilitarSiguiente,
}) => {
  const [comentarios, setComentarios] = useState("");
  const [estatus, setEstatus] = useState({});
  const [open, setOpen] = useState(false); // Estado para controlar si el modal está abierto o cerrado
  const [selectedDate, setSelectedDate] = useState(''); // Estado para almacenar la fecha seleccionada

  const onChange = (prop, value, sbool, smensaje) => {
    setComentarios(value);
  };
  const [condiciones, setCondiciones] = useState({})




  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`ACAnalisisDecicion/Condiciones?folio=${folio}`)
      .then((result) => {
        // setLoader({ ...loader, mostrar: false });
        setCondiciones(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "VALIDAR CONDICIONES DE LA OPERACION",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `AC_Validar_Condiciones_Operacion/ValidarCondicionesOperacion?folio=${folio}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result);
        const fechaSoloFecha = result.fecha_pagare.split('T')[0];
        setSelectedDate(fechaSoloFecha);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }, []);
  const onImprimirArchivo = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerDocumentoPedido?folio=${folio}&iddocumento=${Number(
          25
        )}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = result.documento;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("ANALISIS DE SOLICITUD DE CREDITO", error.mensaje, "error");
      });
  };
  const OnGetIcon = ({ icon }) => {
    switch (icon) {
      case "wait":
        return <PendingIcon />;
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <WarningIcon />;
      case "error":
        return <ErrorIcon />;
      default:
        <></>;
    }
  };

  const onEnviarComentario = (valor) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "VALIDAR CONDICIONES DE LA OPERACION",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      comentarios,
      estatus: valor,
      idproceso: idproceso,
    };
    request
      .post("AC_Validar_Condiciones_Operacion/EnviarComentario", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);

        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();

        // Habilita "Siguiente" sin recargar data/estado ni cerrar el modal.
        if (
          valor === "A" &&
          habilitarSiguiente !== undefined &&
          habilitarSiguiente !== null
        )
          habilitarSiguiente();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };

  const onEnviarModificar = (valor) => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "VALIDAR CONDICIONES DE LA OPERACION",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio,
      comentarios,
      estatus: valor,
      idproceso: idproceso,
      fecha_pagare: selectedDate
    };
    request
      .post("AC_Validar_Condiciones_Operacion/EnviarModificacion", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setEstatus(result.estado);
       
        handleClose()
        setComentarios("");
        if (updateComentarios !== undefined && updateComentarios !== null)
          updateComentarios();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  };


  // Función para abrir el modal
  const handleClickOpen = () => {
    const rescomentarios = ValFormReg(
      "Comentarios",
      comentarios,
      RegularExpressions.TextSpecialCharacter,
      15,
      2000
    );
    if (rescomentarios.isValid === false) {
      Swal.fire(
        "ANALISIS DE SOLICITUD DE CREDITO",
        rescomentarios.mensaje,
        "error"
      );
      return;
    }

    setOpen(true);
  };

  // Función para cerrar el modal
  const handleClose = () => {
    setOpen(false);
  };

  // Función para manejar el cambio en el input de tipo date
  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  return (
    <div className="analisis-credito-modal-mhusa">
      <div className="analisis-credito-modal-mhusa-content">
        <div className="analisis-credito-modal-mhusa-content-buttons">
          <div
            className="analisis-credito-modal-mhusa-content-pdf"
            onClick={() => onImprimirArchivo()}
          >
            <CloudDownloadIcon />
            <div>Descargar pedido original</div>
          </div>
          {estatus.habilitar === undefined ||
            estatus.habilitar === null ||
            estatus.habilitar === false ? (
            <div
              className={`analisis-credito-modal-mhusa-content-comentarios analisis-credito-modal-pedido-content-comentarios-${estatus.icono}`}
            >
              <div className="analisis-credito-modal-mhusa-content-comentarios-svg">
                <OnGetIcon icon={estatus.icono} />
              </div>
              <div className="analisis-credito-modal-mhusa-content-comentarios-div">
                {estatus.comentarios}
              </div>
            </div>
          ) : (
            <div className="modal-validacion-pedido-container-main">
              <div className="modal-validacion-pedido-container-validar-informacion scroll">
                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline analisis-credito-modal-pedido-content-condiciones-credito-timeline`}
                >
                  <label>Condiciones</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg">
                    {/* <OnGetIcon icon={estatus.icono} /> */}
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div">
                    {condiciones.condiciones}
                  </div>
                </div>
                <div
                  className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline analisis-credito-modal-pedido-content-condiciones-credito-timeline`}
                >
                  <label>Observaciones</label>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg">
                    {/* <OnGetIcon icon={estatus.icono} /> */}
                  </div>
                  <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div">
                    {condiciones.observaciones}
                  </div>
                </div>
                <div className="analisis-condiciones-credito-timeline-two-labels">
                  <div
                    className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels`}
                  >
                    <label>Deposito</label>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-two-labels">
                      <AttachMoneyIcon />
                    </div>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-two-labels">
                      {condiciones.deposito}
                    </div>
                  </div>                <div
                    className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-two-labels`}
                  >
                    <label>Anticipo</label>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-two-labels">
                      <AttachMoneyIcon />
                    </div>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-two-labels">
                      {condiciones.anticipo}
                    </div>
                  </div>
                </div>
                <div className="analisis-condiciones-credito-timeline-three-labels">
                  <div
                    className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                  >
                    <label>Tasa</label>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">
                      <PercentIcon />
                    </div>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                      {condiciones.taza}
                    </div>
                  </div>
                  <div
                    className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                  >
                    <label>Plazo</label>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">
                      <CalendarMonthIcon />
                    </div>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                      {condiciones.plazo}
                    </div>
                  </div>                <div
                    className={`analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels analisis-credito-modal-pedido-content-condiciones-credito-timeline-three-labels`}
                  >
                    <label>Tiempo</label>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-svg-three-labels">
                      <AccessTimeIcon />
                    </div>
                    <div className="analisis-credito-modal-pedido-content-condiciones-credito-timeline-div-three-labels">
                      {condiciones.tiempo_plazo}
                    </div>
                  </div>
                </div>
              </div>
              <div className="analisis-credito-modal-mhusa-content-buttons-container">
                <TextField
                  fullWidth
                  size="small"
                  label="COMENTARIOS"
                  className=""
                  multiline
                  rows={5}
                  type="text"
                  onChange={({ target }) => {
                    ValSpecialCharacters(
                      "condiciones",
                      target.value,
                      onChange,
                      true,
                      500
                    );
                  }}
                  value={comentarios}
                />
                <dvi className="analisis-credito-modal-mhusa-content-buttons-container-buttons">
                  <div
                    className="analisis-credito-modal-mhusa-content-acept-button"
                    onClick={() => {
                      onEnviarComentario("A");
                    }}
                  >
                    <CheckCircleIcon />
                    <div>Aceptar condiciones de la operación</div>
                  </div>
                  <div
                    className="analisis-credito-modal-mhusa-content-warning-button"
                    onClick={() => handleClickOpen()}
                  >
                    <WarningIcon />
                    <div>Solicitar cambio en las condiciones</div>
                  </div>
                </dvi>
              </div>
            </div>
          )}
        </div>
        {/* Modal usando el componente Dialog de MUI */}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Selecciona una fecha para el pagare</DialogTitle>
          <DialogContent>
            {/* Input tipo date */}
            <input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              style={{ width: '100%', height: '30px' }}
            />
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Botón de Cerrar alineado a la izquierda */}
            <Button onClick={handleClose} color="primary" sx={{ alignSelf: 'flex-start' }}>
              Cerrar
            </Button>

            {/* Botón de Guardar alineado a la derecha */}
            <Button
              onClick={() => onEnviarModificar("M")}
              color="primary"
              sx={{ alignSelf: 'flex-end' }}>
              Guardar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};